import Client from "./Client";

export const apiV3 = (new Client(`${process.env.REACT_APP_HTTP_LINK_V3}`)).client;
